module.exports = __webpack_public_path__ + "empty-cart.77a20e6f0cc61d313d9dcfb5fe1d0ff1.svg";